"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var VideoMask_1 = __importDefault(require("./VideoMask"));
function ImageVideo(props) {
    var style = props.style, className = props.className, source = props.source, backgroundUrl = props.backgroundUrl, width = props.width, height = props.height, onClick = props.onClick, extendProps = props.extendProps;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    function alert() {
        var div = document.createElement('div');
        document.body.appendChild(div);
        ReactDOM.render(react_1.default.createElement(VideoMask_1.default, { source: source, onClose: function () {
                var unmountResult = ReactDOM.unmountComponentAtNode(div);
                if (unmountResult && div.parentNode) {
                    div.parentNode.removeChild(div);
                }
            } }), div);
    }
    function handleClickTC() {
        if (onClick) {
            onClick();
            return;
        }
        alert();
    }
    function renderButton() {
        return (react_1.default.createElement("div", { className: "video-button" },
            react_1.default.createElement("div", { className: "svg-wrapper" },
                react_1.default.createElement("svg", { className: "svg-icon", width: "60px", height: "60px", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 114 114" },
                    react_1.default.createElement("g", { fillRule: "nonzero", fill: "none" },
                        react_1.default.createElement("path", { d: "M38.0878099,30.0390178 L82.4381908,54.7230515 C82.8122427,54.9312371 82.9436418,55.3978303 82.7316792,55.7652167 C82.6622131,55.8856194 82.560778,55.9852469\n              82.4381908,56.0534751 L38.0878099,80.7375088 C37.7137579,80.9456943 37.2386992,80.8166367 37.0267364,80.4492504 C36.960414,80.3342966 36.9255533,80.2044243 36.9255533,80.072297\n                L36.9255533,30.7042296 C36.9255533,30.2819572 37.2740835,29.9396378 37.7040173,29.9396378 C37.8385418,29.9396378 37.9707706,29.9738775 38.0878099,30.0390178 Z", fill: "#FFF", transform: "translate(2.303823 2.61167)" }))))));
    }
    function renderTcVideo() {
        return (react_1.default.createElement("div", __assign({ className: "tc-video", onClick: handleClickTC }, extendProps),
            react_1.default.createElement("div", { className: "video-img", style: { backgroundImage: "url(".concat(backgroundUrl, ")") } }),
            renderButton()));
    }
    return (react_1.default.createElement("div", { style: __assign({ width: width, height: height }, style), className: (0, classnames_1.default)("".concat(classPrefix, "-image-video"), className) }, renderTcVideo()));
}
exports.default = ImageVideo;
//# sourceMappingURL=ImageVideo.js.map